var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 395,
    height: 392,
    viewBox: "0 0 395 392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32092",
    "data-name": "Group 32092",
    transform: "translate(-66 -65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32091",
    "data-name": "Group 32091",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -104.866, -899.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109927",
    "data-name": "Path 109927",
    d: "M25.99,0,193.82,55.743l-9.488,41.511L0,72.954",
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 720.114, 992.525)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_550",
    "data-name": "Ellipse 550",
    cx: 59.361,
    cy: 59.362,
    rx: 59.361,
    ry: 59.362,
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 779.734, 917.289)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9967",
    "data-name": "Line 9967",
    x1: 19.384,
    y2: 64.84,
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 692.409, 1038.371)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9968",
    "data-name": "Line 9968",
    x1: 18.058,
    y2: 53.786,
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 659.578, 1088.976)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOral);
export default __webpack_public_path__ + "static/media/ic_oral.55b345117f3f1069d374970616612507.svg";
export { ForwardRef as ReactComponent };